<template>
  <Container
    :class="{'container--tablet': this.$vuetify.breakpoint.md}"
  >
    <template #component>
      <v-col class="container__col">
        <SettingsInfo />
      </v-col>
    </template>
  </Container>
</template>

<script>
import { breakpoints } from '@/mixins'
import Container from '@/views/Layout/Container.vue'
import SettingsInfo from '@/components/Settings-Info/Settings.vue'

export default {
  name: 'Settings',
  components: {
    Container,
    SettingsInfo,
  },
  mixins: [breakpoints],
}
</script>
